import React from 'react'
import { Image } from 'react-native'
import { styles } from './styles'
import logo from './verizon.png'

export const LogoVerizon = () => <Image resizeMode="contain" style={styles.image} source={{uri:logo}} />
